import React, { Component } from "react";
import { List, Spin, Alert } from "antd";
import InfiniteScroll from "react-infinite-scroller";

import { FormattedMessage, injectIntl } from "react-intl";

import { debounce } from "../../utils/debounce";
import { mobileDetect } from "../../utils/mobileDetect";

import { connect } from "react-redux";
import MessageItem from "./MessageItem";

import { setAllUsersInactive } from "../../store/actions/users";

import "./MessageList.scss";

class MessageList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "message-list-" + this.props.id,
      messageContainerRef: null,
      prevScrollTop: 0,
      countUsersInactive: 0,
    };
    this.dismissNewMessageSpam = this.dismissNewMessageSpam.bind(this);
    this.setContainerRef = this.setContainerRef.bind(this);
  }

  componentDidMount() {
    if (mobileDetect()) {
      window.addEventListener("resize", this.handleMessageScroll);
    }
  }

  componentWillUnmount() {
    if (mobileDetect()) {
      window.removeEventListener("resize", this.handleMessageScroll);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.loadingMore || this.props.loadingMore) {
      return;
    }

    const container = this.state.messageContainerRef;

    if (!container || prevProps.list.length === this.props.list.length) {
      return;
    }

    if (
      container.scrollTop === this.state.prevScrollTop ||
      prevProps.list.length === 0
    ) {
      container.scrollTop = container.scrollHeight;
      this.setState({
        prevScrollTop: container.scrollTop,
      });

      return;
    }

    if (
      container.scrollTop !== this.state.prevScrollTop &&
      !this.props.isLastMessageFromCurrentUser
    ) {
      this.props.setNewMessagesToScrollCount(true);
    }
  }

  handleMessageScroll = debounce(() => {
    if (this.state.messageContainerRef) {
      this.state.messageContainerRef.scrollTo(
        0,
        this.state.messageContainerRef.scrollHeight
      );
    }
  }, 300);

  dismissNewMessageSpam(event) {
    let elem = event.target;
    if (elem.scrollHeight - elem.scrollTop === elem.clientHeight) {
      this.props.setNewMessagesToScrollCount(false, 0);
    }
  }

  setContainerRef(node) {
    node && node.addEventListener("scroll", this.dismissNewMessageSpam);

    if (!node) {
      this.state.messageContainerRef.removeEventListener(
        "scroll",
        this.dismissNewMessageSpam
      );
    }

    this.setState(
      {
        messageContainerRef: node,
      },
      () => {
        if (node && this.props.list.length > 0) {
          node.scrollTop = node.scrollHeight;
          this.setState({ prevScrollTop: node.scrollTop });
        }
      }
    );

    this.props.setMessageListRef && this.props.setMessageListRef(node);
  }

  render() {
    const users = this.props.chat?.recipients || [];
    const activeUsers = users.filter((user) => user.isActive);

    const showAlert =
      activeUsers.length < users.length &&
      !this.props.loadingActiveUsers &&
      !this.props.fetchActiveUsersError;

    return (
      <div className="message-list-container" ref={this.setContainerRef}>
        {this.props.fetchActiveUsersError && (
          <div className="alert-container">
            <Alert
              description={<FormattedMessage id="chat.fetchActiveUsersError" />}
              type="error"
              showIcon={false}
              className="social-alert"
              banner
            />
          </div>
        )}

        {showAlert && (
          <div className="alert-container">
            <div
              className="some-users"
              direction="vertical"
              style={{ width: "100%" }}
            >
              {activeUsers.length === 0 && (
                <Alert
                  description={<FormattedMessage id="chat.allUsersInactive" />}
                  type="error"
                  showIcon={false}
                  className="social-alert"
                  banner
                />
              )}

              {activeUsers.length > 0 && activeUsers.length < users.length && (
                <Alert
                  description={<FormattedMessage id="chat.someUsersInactive" />}
                  type="error"
                  showIcon={false}
                  className="social-alert"
                  banner
                />
              )}
            </div>
          </div>
        )}

        <InfiniteScroll
          loadMore={this.props.handleInfiniteOnLoad}
          hasMore={this.props.hasMorePages}
          initialLoad={false}
          isReverse={true}
          useWindow={false}
        >
          <List
            id={this.state.id}
            className="message-list"
            locale={{ emptyText: "" }}
            dataSource={this.props.list}
            loading={this.props.loading}
            header={this.props.hasMorePages && <Spin />}
            renderItem={(item, index) => (
              <MessageItem
                item={item}
                previousItem={this.props.list[index - 1]}
                index={index}
              />
            )}
          />
        </InfiniteScroll>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    chats: state.Chats.chats,
    fetchActiveUsersError: state.Users.fetchActiveUsersError,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setAllUsersInactive: (inactive) => dispatch(setAllUsersInactive(inactive)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MessageList));
